<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div
    [ngStyle]="{
      backgroundColor: styles.colors['other']['background'],
    }">
    <div>
      @if (items[0].value.url) {
        <img class="w-full" [src]="items[0].value.url" />
      }
    </div>
    <div class="mt-3 mb-3">
      <div
        class="text-center text-lg font-bold"
        [attr.style]="buildStyle('text', items[1].styles?.text)">
        {{ items[1].value.text }}
      </div>
      <div
        class="text-center"
        [attr.style]="buildStyle('text', items[2].styles?.text)" [innerHTML]="items[2].value.text | lineBreak">
      </div>
    </div>
    <div>
      <div
        class="text-center p-[10px] border-2 border-solid mt-[5px] mb-[5px] rounded bg-transparent"
        [attr.style]="buildStyle('button', items[3].styles?.button)">
        <a
          [ngStyle]="{
            color: 'inherit',
            fontSize: 'inherit',
            fontWeight: 'inherit',
            fontFamily: 'inherit',
            backgroundColor: 'inherit',
            textAlign: 'inherit',
          }"
          [href]="items[3].value.url"
          target="_blank"
          class="no-underline"
          >{{ items[3].value.label }}</a
        >
      </div>
    </div>
  </div>
</div>
